import { render } from "./GoalModal.vue?vue&type=template&id=5877815c&scoped=true"
import script from "./GoalModal.vue?vue&type=script&lang=js"
export * from "./GoalModal.vue?vue&type=script&lang=js"

import "./GoalModal.vue?vue&type=style&index=0&id=5877815c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5877815c"]])

export default __exports__